<div class="wiz-integration-content">
    <div id="full-content" class="wiz-integration-group">
        <div class="step-header">
            {{'SPECIAL_MSG.ADD_TURF_PRO_API_TOKEN' | translate}}
        </div>
        <toro-step-group *ngFor="let step of stepsCount | fill; let i = index;" [ngSwitch]="i" [stepNumber]="i + 1">
            <ng-container *ngSwitchCase="0" [ngTemplateOutlet]="step1"></ng-container>
        </toro-step-group>

        <toro-step-action>
            <div>
                <img src="assets/images/wizard/TurfPro.png" alt="Turf Pro Logo">
            </div>
            <div class="wic-perry-weather-info">
                <div>{{'CASE_SENSITIVE.ENTER_TURF_PRO_PAT' | translate}}</div>
                <input type="text" pInputText
                        [(ngModel)]="turfProApiToken"
                        class="perry-weather-integration-key"
                        [size]="80"
                        [placeholder]="'CASE_SENSITIVE.ENTER_TOKEN' | translate"
                        (paste)="onPasteApiKey($event)"
                        (cut)="onCutApiKey($event)"
                />
                <div *ngIf="showError" id="wic-perry-weather-error">{{'SPECIAL_MSG.TURF_PRO_DATA_COULD_NOT_BE_RETRIEVED' | translate}}</div>
                <toro-waiting-indicator class="widget-non-draggable" *ngIf="isBusy" [isVisible]="isBusy" text="{{spinnerText | translate}}..." backgroundColor="rgba(255,255,255, .9)"></toro-waiting-indicator>
            </div>
        </toro-step-action>
    </div>
</div>

<ng-template #step1>
    <div id="step1">
        {{'SPECIAL_MSG.TURF_PRO_SW_ENTER_ID' | translate}}
    </div>
</ng-template>

